/* Campaign film: load on demand, pause offscreen, respect reduced motion/data. */
(() => {
  'use strict';
  const instances = new WeakMap();
  function init(scope = document) {
    scope.querySelectorAll('[data-campaign-film]').forEach(section => {
      if (instances.has(section)) return;
      const video = section.querySelector('video');
      const button = section.querySelector('[data-film-toggle]');
      const label = button.querySelector('[data-film-label]');
      const progress = section.querySelector('[data-film-progress]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const mobile = matchMedia('(max-width: 989px)');
      const connection = navigator.connection;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      let wanted = !reduced.matches && !connection?.saveData;
      let visible = true, ready = document.readyState === 'complete', disposed = false;
      let observer;
      const showState = () => {
        const playing = !video.paused && !video.ended;
        section.dataset.filmState = playing ? 'playing' : 'paused';
        label.textContent = playing ? button.dataset.pause : button.dataset.play;
        button.setAttribute('aria-label', label.textContent);
      };
      function sync() {
        if (disposed) return;
        if (!wanted || !visible || document.hidden || !ready) { video.pause(); showState(); return; }
        const src = mobile.matches && video.dataset.mobile ? video.dataset.mobile : video.dataset.desktop;
        if (video.getAttribute('src') !== src) {
          section.classList.remove('film-loaded');
          video.src = src;
          video.load();
        }
        video.play()?.catch(error => { if (error.name !== 'AbortError') wanted = false; showState(); });
      }
      button.hidden = false;
      button.addEventListener('click', () => { wanted = video.paused; ready = true; sync(); }, options);
      video.addEventListener('playing', () => { section.classList.add('film-loaded'); showState(); }, options);
      video.addEventListener('pause', showState, options);
      video.addEventListener('error', () => { wanted = false; section.classList.remove('film-loaded'); button.hidden = true; }, options);
      video.addEventListener('timeupdate', () => {
        if (progress && Number.isFinite(video.duration) && video.duration > 0) progress.style.transform = `scaleX(${video.currentTime / video.duration})`;
      }, options);
      document.addEventListener('visibilitychange', sync, options);
      reduced.addEventListener('change', () => { wanted = !reduced.matches && !connection?.saveData; sync(); }, options);
      connection?.addEventListener('change', () => { if (connection.saveData) wanted = false; sync(); }, options);
      mobile.addEventListener('change', sync, options);
      window.addEventListener('load', () => { ready = true; sync(); }, { ...options, once: true });
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, { threshold: .05 });
        observer.observe(section);
      }
      instances.set(section, () => { disposed = true; video.pause(); observer?.disconnect(); controller.abort(); });
      showState(); sync();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-campaign-film]').forEach(section => instances.get(section)?.()));
})();
